(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ch-category-opening"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('coastline-category-navigation')) {
 customElements.define('coastline-category-navigation',class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort();this.abort=new AbortController();
   this.currentPath=location.pathname;
   this.revealActiveCategory();
   this.addEventListener('click',event=>{
    const link=event.target.closest('[data-category-link]');
    if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const url=new URL(link.href,location.href);
    if(url.origin!==location.origin)return;
    event.preventDefault();
    if(url.pathname!==this.currentPath)this.navigate(url,true);
   },{signal:this.abort.signal});
   window.addEventListener('popstate',()=>{
    if(location.pathname!==this.currentPath)this.navigate(new URL(location.href),false);
   },{signal:this.abort.signal});
  }
  revealActiveCategory() {
   const row=this.querySelector('.cc-navigation__links'),active=row?.querySelector('[aria-current="page"]');
   if(row&&active&&row.scrollWidth>row.clientWidth)row.scrollLeft=Math.max(0,active.offsetLeft-row.offsetLeft-row.clientWidth/2+active.clientWidth/2);
  }
  async navigate(url,push) {
   this.request?.abort();this.request=new AbortController();
   const signal=this.request.signal;
   const previousNavTop=this.querySelector('.cc-navigation').getBoundingClientRect().top;
   const startScroll=scrollY;
   this.setAttribute('aria-busy','true');
   const status=this.querySelector('[data-category-status]');if(status)status.textContent='Loading collection.';
   try {
    const response=await fetch(url.href,{signal});
    if(!response.ok)throw new Error('Collection unavailable');
    const html=new DOMParser().parseFromString(await response.text(),'text/html');
    const opening=html.querySelector('[data-category-catalog]');
    const oldGrid=document.querySelector('dynamic-product-search');
    const newGrid=html.querySelector('dynamic-product-search');
    const previewGrid=document.querySelector('.cc-preview-grid');
    if(!opening)throw new Error('Different collection template');
    if(oldGrid&&newGrid&&typeof oldGrid.renderCollection==='function'&&oldGrid.dataset.section===newGrid.dataset.section) {
     oldGrid.abortController?.abort();
     const oldData={...oldGrid.dataset};
     try {
      Object.assign(oldGrid.dataset,newGrid.dataset);
      await new Promise((resolve,reject)=>{
       const cleanup=()=>{oldGrid.removeEventListener('on:dynamic-product-search:loaded',loaded);oldGrid.removeEventListener('on:dynamic-product-search:failed',failed);signal.removeEventListener('abort',aborted);};
       const loaded=()=>{cleanup();resolve();};
       const failed=()=>{cleanup();reject(new Error('Product update failed'));};
       const aborted=()=>{oldGrid.abortController?.abort();cleanup();reject(new DOMException('Aborted','AbortError'));};
       oldGrid.addEventListener('on:dynamic-product-search:loaded',loaded,{once:true});
       oldGrid.addEventListener('on:dynamic-product-search:failed',failed,{once:true});
       signal.addEventListener('abort',aborted,{once:true});
       oldGrid.renderCollection({query:url.searchParams.toString(),updateURL:false,scrollUp:false});
      });
     }catch(error){if(error.name!=='AbortError')Object.assign(oldGrid.dataset,oldData);throw error;}
    } else if(previewGrid&&html.querySelector('.cc-preview-grid')) {
     previewGrid.replaceWith(html.querySelector('.cc-preview-grid'));
    } else throw new Error('Collection renderer unavailable');
    if(signal.aborted)return;
    if(push)history.pushState({...history.state,coastlineCategory:true},'',url.href);
    const oldControls=document.querySelector('coastline-shop-controls');
    const newControls=html.querySelector('coastline-shop-controls');
    if(oldControls&&newControls)oldControls.replaceWith(newControls);
    else if(oldControls)oldControls.remove();
    else if(newControls)oldGrid?.closest('[data-section-type="collection-template"]')?.before(newControls);
    this.innerHTML=opening.innerHTML;
    this.revealActiveCategory();
    this.currentPath=url.pathname;
    document.title=html.title;
    const canonical=html.querySelector('link[rel="canonical"]');
    if(canonical&&document.querySelector('link[rel="canonical"]'))document.querySelector('link[rel="canonical"]').href=canonical.href;
    if(Math.abs(scrollY-startScroll)<4)window.scrollBy({top:this.querySelector('.cc-navigation').getBoundingClientRect().top-previousNavTop,behavior:'instant'});
    this.querySelector('[aria-current="page"]')?.focus({preventScroll:true});
    const updated=this.querySelector('[data-category-status]');if(updated)updated.textContent='Collection updated.';
    if(window.Shopify?.PaymentButton)window.Shopify.PaymentButton.init();
   }catch(error){if(error.name!=='AbortError')location.assign(url.href);}
   finally{if(!signal.aborted)this.removeAttribute('aria-busy');}
  }
  disconnectedCallback(){this.abort?.abort();this.request?.abort();}
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-contact-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const result = document.querySelector('[data-contact-editorial] [data-contact-result]');
    if (!result || window.Shopify?.designMode) return;
    const showResult = () => requestAnimationFrame(() => {
      result.focus({ preventScroll: true });
      result.scrollIntoView({ block: 'center', behavior: 'instant' });
    });
    if (document.readyState === 'complete') showResult();
    else window.addEventListener('load', showResult, { once: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-drop-collection-controls"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('coastline-drop-controls')) {
  customElements.define('coastline-drop-controls', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const links = [...this.querySelectorAll('[data-drop-types]')];
      const select = this.querySelector('[name="sort_by"]');
      const form = this.querySelector('form');
      const status = this.querySelector('[data-drop-status]');
      const grid = document.querySelector('dynamic-product-search');
      let pendingURL = null;
      const typeKey = 'filter.p.product_type';
      const baseURL = () => {
        const url = new URL(pendingURL || location.href);
        url.pathname = this.dataset.collectionUrl;
        url.searchParams.delete('page');
        url.hash = 'drop-lineup';
        return url;
      };
      const values = text => text.split(',').map(value => value.trim()).filter(Boolean);
      const sync = () => {
        const params = new URL(pendingURL || location.href).searchParams;
        const active = params.getAll(typeKey).flatMap(values).sort();
        links.forEach(link => {
          const group = values(link.dataset.dropTypes).sort();
          const selected = JSON.stringify(group) === JSON.stringify(active);
          link.classList.toggle('is-active', selected);
          if (selected) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
          const url = baseURL();
          url.searchParams.delete(typeKey);
          group.forEach(value => url.searchParams.append(typeKey, value));
          link.href = url.href;
        });
        const currentSort = params.get('sort_by') || this.dataset.defaultSort;
        if (currentSort && [...select.options].some(option => option.value === currentSort)) select.value = currentSort;
      };
      const updateProducts = url => {
        if (!grid || typeof grid.renderCollection !== 'function') {
          location.assign(url.href);
          return;
        }
        // Use Venue's existing section renderer. Do not navigate or scroll the page.
        grid.abortController?.abort();
        pendingURL = url.href;
        this.setAttribute('aria-busy', 'true');
        if (status) status.textContent = 'Updating products…';
        sync();
        grid.renderCollection({query: url.searchParams.toString(), updateURL: true, scrollUp: false});
      };
      links.forEach(link => link.addEventListener('click', event => {
        if (link.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        const url = baseURL();
        url.searchParams.delete(typeKey);
        values(link.dataset.dropTypes).forEach(value => url.searchParams.append(typeKey, value));
        updateProducts(url);
      }, {signal}));
      const sort = event => {
        event.preventDefault();
        const url = baseURL();
        url.searchParams.set('sort_by', select.value);
        updateProducts(url);
      };
      form.addEventListener('submit', sort, {signal});
      select.addEventListener('change', sort, {signal});
      window.addEventListener('popstate', sync, {signal});
      // Venue can update filters without a page reload. Keep these controls in sync.
      grid?.addEventListener('on:dynamic-product-search:loaded', () => {
        pendingURL = null;
        this.removeAttribute('aria-busy');
        if (status) status.textContent = 'Products updated.';
        sync();
      }, {signal});
      grid?.addEventListener('on:dynamic-product-search:failed', () => {
        pendingURL = null;
        this.removeAttribute('aria-busy');
        if (status) status.textContent = 'Could not update products. Please try again.';
        sync();
      }, {signal});
      sync();
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-drop-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('coastline-drop-editorial')) {
  customElements.define('coastline-drop-editorial', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-d1-filter]');
        if (!button || !this.contains(button)) return;
        const chapter = button.closest('[data-d1-tees]');
        const audience = button.dataset.d1Filter;
        chapter.querySelectorAll('[data-d1-filter]').forEach(tab => tab.setAttribute('aria-pressed', String(tab === button)));
        chapter.querySelectorAll('[data-d1-audience]').forEach(card => { card.hidden = audience !== 'all' && card.dataset.d1Audience !== audience; });
        chapter.querySelector('.d1-products').classList.toggle('is-filtered', audience !== 'all');
        const count = chapter.querySelectorAll('[data-d1-audience]:not([hidden])').length;
        chapter.querySelector('[data-d1-status]').textContent = count + ' ' + (count === 1 ? 'tee' : 'tees') + ' shown.';
      }, {signal:this.events.signal});
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-launch-countdown"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('coastline-launch-countdown')) {
 customElements.define('coastline-launch-countdown',class extends HTMLElement {
  static parts(milliseconds) {
   const total=Math.max(0,Math.ceil(milliseconds/1000));
   return {days:Math.floor(total/86400),hours:Math.floor(total%86400/3600),minutes:Math.floor(total%3600/60),seconds:total%60};
  }
  connectedCallback() {
   this.abort?.abort();clearInterval(this.interval);this.abort=new AbortController();
   const initialize=()=>{
    if(!this.isConnected)return;
    const target=Date.parse(this.dataset.launchAt);
    const timer=this.querySelector('[data-countdown]');
    const finished=this.querySelector('[data-countdown-finished]');
    if(!Number.isFinite(target)||!timer||!finished)return;
    const update=()=>{
     const remaining=target-Date.now();
     const parts=this.constructor.parts(remaining);
     Object.entries(parts).forEach(([unit,value])=>{const span=this.querySelector(`[data-unit="${unit}"]`);if(span)span.textContent=String(value).padStart(2,'0');});
     timer.hidden=remaining<=0;finished.hidden=remaining>0;
     if(remaining<=0)clearInterval(this.interval);
    };
    update();if(target>Date.now())this.interval=setInterval(update,1000);
    document.addEventListener('visibilitychange',update,{signal:this.abort.signal});
   };
   if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true,signal:this.abort.signal});else initialize();
  }
  disconnectedCallback(){clearInterval(this.interval);this.abort?.abort();}
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-lookbook"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('coastline-print-stack')) {
  customElements.define('coastline-print-stack', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const cards = [...this.querySelectorAll('.print-stack__card')];
      if (!cards.length) return;
      this.style.setProperty('--stack-height', String(cards.length * 65 + 100));
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const angles = [-3, 3.5, -2, 4, -1.5, 2, -3, 1];
      const title = this.querySelector('[data-stack-title]');
      const counter = this.querySelector('[data-stack-counter]');
      const number = this.querySelector('[data-stack-number]');
      const link = this.querySelector('[data-stack-link]');
      const previous = this.querySelector('[data-stack-prev]');
      const next = this.querySelector('[data-stack-next]');
      let active = -2;
      let ticking = false;
      const clamp = value => Math.max(0, Math.min(1, value));
      const draw = () => {
        ticking = false;
        const stage = this.querySelector('.print-stack__stage');
        const distance = Math.max(1, this.offsetHeight - stage.offsetHeight);
        const progress = clamp(-this.getBoundingClientRect().top / distance);
        const position = progress * cards.length;
        const current = Math.max(-1, Math.min(cards.length - 1, Math.floor(position - .35)));
        cards.forEach((card, index) => {
          if (reduced.matches) {
            card.style.transform = '';
            card.style.opacity = '';
            card.removeAttribute('aria-hidden');
            card.inert = false;
            card.style.pointerEvents = '';
            return;
          }
          const arrival = clamp(position - index);
          const eased = 1 - Math.pow(1 - arrival, 3);
          const passed = Math.max(0, position - index - 1);
          card.style.opacity = arrival > 0 ? '1' : '0';
          card.style.transform = `translateY(${(1 - eased) * (stage.offsetHeight + 120)}px) rotate(${angles[index % angles.length] + (1 - eased) * -14}deg) scale(${1 - Math.min(passed, 3) * .025})`;
          card.style.zIndex = String(index + 1);
          card.setAttribute('aria-hidden', String(index !== current));
          card.inert = index !== current;
          card.style.pointerEvents = index === current ? 'auto' : 'none';
        });
        if (active !== current) {
          active = current;
          this.querySelector('.print-stack__details').style.visibility = current < 0 ? 'hidden' : 'visible';
          title.textContent = current < 0 ? '' : cards[current].dataset.title;
          const label = String(current + 1).padStart(2, '0');
          counter.textContent = `${label} / ${String(cards.length).padStart(2, '0')}`;
          number.textContent = label;
          const url = current < 0 ? '' : cards[current].dataset.url;
          link.hidden = !url;
          link.textContent = current < 0 ? '' : cards[current].dataset.cta;
          this.querySelector('[data-stack-kind]').textContent = current >= 0 && cards[current].dataset.kind === 'cover' ? 'THE DROP' : 'THE LINEUP';
          if (url) link.href = url;
          else link.removeAttribute('href');
          previous.disabled = current < 0;
          next.disabled = current === cards.length - 1;
        }
        this.querySelector('.print-stack__progress span').style.width = `${progress * 100}%`;
      };
      const requestDraw = () => {
        if (!ticking) { ticking = true; this.frame = requestAnimationFrame(draw); }
      };
      const go = index => {
        const target = Math.max(-1, Math.min(cards.length - 1, index));
        const distance = this.offsetHeight - this.querySelector('.print-stack__stage').offsetHeight;
        const top = scrollY + this.getBoundingClientRect().top;
        scrollTo({top: top + (target + 1) / cards.length * distance, behavior: reduced.matches ? 'instant' : 'smooth'});
      };
      previous.addEventListener('click', () => go(active - 1), {signal});
      next.addEventListener('click', () => go(active + 1), {signal});
      window.addEventListener('scroll', requestDraw, {passive: true, signal});
      window.addEventListener('resize', requestDraw, {signal});
      reduced.addEventListener('change', requestDraw, {signal});
      draw();
    }
    disconnectedCallback() {
      this.abort?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-nfa-message"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('coastline-nfa-message')) {
  customElements.define('coastline-nfa-message',class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort=new AbortController();
      const signal=this.abort.signal;
      const reduced=matchMedia('(prefers-reduced-motion: reduce)');
      const initialize=()=>{
        if (!this.isConnected) return;
        this.querySelectorAll('[data-nfa-lines]').forEach(group=>{
          if (group.dataset.prepared) return;
          const lines=group.innerText.split(/\n/).filter(line=>line.trim());
          group.replaceChildren(...lines.map((line,index)=>{
            const span=document.createElement('span');
            span.textContent=line;
            span.style.setProperty('--line-index',index);
            return span;
          }));
          group.dataset.prepared='true';
        });
        this.classList.add('nfa-interactive');
        const targets=[...this.querySelectorAll('[data-nfa-reveal],[data-nfa-lines]')];
        const motion=this.dataset.motion==='true'&&!reduced.matches&&'IntersectionObserver' in window;
        this.classList.toggle('nfa-motion',motion);
        this.observer?.disconnect();
        if (motion) {
          this.observer=new IntersectionObserver(entries=>{
            entries.forEach(entry=>{
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              this.observer.unobserve(entry.target);
            });
          },{threshold:.12,rootMargin:'0px 0px -3% 0px'});
          targets.forEach(target=>this.observer.observe(target));
        } else targets.forEach(target=>target.classList.add('is-visible'));
      };
      this.addEventListener('click',event=>{
        const button=event.target.closest('[data-nfa-zoom]');
        if (!button || !this.contains(button)) return;
        const zoomed=button.getAttribute('aria-pressed')!=='true';
        button.setAttribute('aria-pressed',String(zoomed));
        button.closest('[data-nfa-detail]').classList.toggle('is-zoomed',zoomed);
        button.querySelector('[data-nfa-zoom-label]').textContent=zoomed?button.dataset.reset:button.dataset.label;
      },{signal});

      const packForm=this.querySelector('[data-nfa-pack-form]');
      if (packForm) {
        const count=packForm.querySelector('[data-nfa-pack-count]');
        count.hidden=false;
        const rows=[...packForm.querySelectorAll('[data-nfa-pack-row]')];
        const setCount=()=>{
          const total=Number(count.querySelector('input:checked').value);
          rows.forEach((row,index)=>{
            row.hidden=index>=total;
            row.querySelectorAll('select,input').forEach(input=>input.disabled=index>=total);
          });
          packForm.querySelector('[data-nfa-pack-status]').textContent='';
        };
        setCount();
        count.addEventListener('change',setCount,{signal});
        packForm.addEventListener('submit',async event=>{
          event.preventDefault();
          if (packForm.dataset.submitting==='true'||!packForm.reportValidity()) return;
          const button=packForm.querySelector('[type="submit"]');
          const status=packForm.querySelector('[data-nfa-pack-status]');
          const originalLabel=button.textContent;
          const quantities=new Map();
          rows.filter(row=>!row.hidden).forEach(row=>{
            const id=row.querySelector('select').value;
            quantities.set(id,(quantities.get(id)||0)+1);
          });
          packForm.dataset.submitting='true';
          button.disabled=true;
          button.textContent=packForm.dataset.busy;
          status.textContent='';
          try {
            const response=await fetch(packForm.dataset.addUrl,{
              method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
              body:JSON.stringify({items:[...quantities].map(([id,quantity])=>({id:Number(id),quantity}))})
            });
            const result=await response.json();
            if (!response.ok) throw new Error(typeof result.description==='string'?result.description:packForm.dataset.error);
            window.location.assign(packForm.dataset.cartUrl);
          } catch(error) {
            status.textContent=error.message||packForm.dataset.error;
            button.disabled=false;
            button.textContent=originalLabel;
            packForm.dataset.submitting='false';
          }
        },{signal});
      }
      if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',initialize,{once:true,signal});
      else initialize();
      reduced.addEventListener('change',initialize,{signal});
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-our-story-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('coastline-our-story')) {
  customElements.define('coastline-our-story', class extends HTMLElement {
    connectedCallback() {
      this.cleanup();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const chapters = [...this.querySelectorAll('[data-story-chapter]')];
      // Reuse the editable second paragraph as the animated phrase cloud.
      this.querySelectorAll('.story-chapter--manifesto').forEach(chapter => {
        if (chapter.querySelector('[data-story-cloud]')) return;
        const text = chapter.querySelector('.story-chapter__text');
        const heading = text?.querySelector('h2');
        const body = text?.querySelector('.story-body');
        const paragraphs = body ? [...body.children] : [];
        const list = paragraphs[1];
        if (!text || !heading || !list || !list.querySelector('br')) return;
        const phrases = [];
        let phrase = '';
        list.childNodes.forEach(node => {
          if (node.nodeName === 'BR') { if (phrase.trim()) phrases.push(phrase.trim()); phrase = ''; }
          else phrase += node.textContent;
        });
        if (phrase.trim()) phrases.push(phrase.trim());
        if (phrases.length < 2) return;
        const stage = document.createElement('div');
        stage.className = 'story-cloud-stage';
        const intro = document.createElement('div');
        intro.className = 'story-manifesto-intro';
        const lead = document.createElement('div');
        lead.className = 'story-body';
        paragraphs.slice(0,1).forEach(item => lead.append(item));
        intro.append(heading,lead);
        const cloud = document.createElement('ul');
        cloud.className = 'story-cloud';
 
        phrases.forEach((value,index) => { const item = document.createElement('li'); item.textContent = value; item.style.setProperty('--phrase-index',index); cloud.append(item); });
        const footer = document.createElement('div');
        footer.className = 'story-body story-manifesto-footer';
        paragraphs.slice(2).forEach(item => footer.append(item));
        stage.append(intro,cloud,footer);
        text.classList.add('story-cloud-scroll');
        text.setAttribute('data-story-cloud','');
        text.replaceChildren(stage);
      });
      const clouds = [...this.querySelectorAll('[data-story-cloud]')];
      const headings = [...this.querySelectorAll('[data-story-heading]')];
      const nav = this.querySelector('.story-chapters');
      const links = nav ? [...nav.querySelectorAll('a')] : [];
      const clamp = value => Math.min(1, Math.max(0, value));
      const motionEnabled = () => this.dataset.motion === 'true' && !reduced.matches;
      const applyMotion = () => {
        this.classList.toggle('story-motion', motionEnabled());
        if (!motionEnabled()) {
          chapters.forEach(chapter => {
            const photo = chapter.querySelector('[data-story-photo]');
            ['--photo-y', '--type-x', '--photo-wipe'].forEach(name => photo?.style.removeProperty(name));
          });
          headings.forEach(heading => heading.classList.add('is-read'));
        }
      };
      if ('IntersectionObserver' in window) {
        this.reveal = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('is-read'); this.reveal.unobserve(entry.target); }
        }), {rootMargin:'0px 0px -8% 0px', threshold:.12});
        headings.forEach(heading => this.reveal.observe(heading));
      } else headings.forEach(heading => heading.classList.add('is-read'));
      const render = () => {
        this.frame = null;
        const height = innerHeight;
        let active = -1;
        chapters.forEach((chapter,index) => {
          const rect = chapter.getBoundingClientRect();
          if (rect.top < height * .58 && rect.bottom > height * .25) active = index;
          const photo = chapter.querySelector('[data-story-photo]');
          if (!photo) return;
          const media = photo.getBoundingClientRect();
          if (media.bottom > -100 && media.top < height + 100 && motionEnabled()) {
            const progress = clamp((height - media.top) / (height + media.height));
            photo.style.setProperty('--photo-y', `${(progress - .5) * media.height * .105}px`);
            photo.style.setProperty('--type-x', `${(progress - .5) * innerWidth * (index % 2 ? -.12 : .12)}px`);
            photo.style.setProperty('--photo-wipe', `${(1 - clamp((height - media.top) / (height * .8))) * 10}%`);
          }
        });
        clouds.forEach(root => {
          const stage = root.querySelector('.story-cloud-stage');
          const items = [...root.querySelectorAll('.story-cloud>li')];
          const enabled = motionEnabled() && innerWidth > 900;
          root.classList.toggle('story-cloud-enabled',enabled);
          const offset = parseFloat(getComputedStyle(stage).top) || 0;
          const progress = clamp((offset - root.getBoundingClientRect().top) / Math.max(1, root.offsetHeight - stage.offsetHeight));
          const list = root.querySelector('.story-cloud');
          const listRect = list.getBoundingClientRect();
          if (motionEnabled() && innerWidth <= 900 && listRect.top < height * .8 && listRect.bottom > 0) root.dataset.mobileRevealed = 'true';
          root.classList.toggle('story-list-revealed',root.dataset.mobileRevealed === 'true');
          items.forEach((item,index) => {

            let reveal = enabled ? clamp((progress - index / Math.max(1,items.length - 1) * .86 + .14) / .14) : 1;
            if (motionEnabled() && innerWidth <= 900) {
              reveal = root.dataset.mobileRevealed === 'true' ? 1 : 0;
            }
            item.style.setProperty('--phrase-opacity',reveal);
            item.style.setProperty('--phrase-y',`${(1-reveal)*18}px`);
          });
        });
        nav?.classList.toggle('is-visible', active >= 0);
        links.forEach((link,index) => {
          if (index === active) link.setAttribute('aria-current', 'step');
          else link.removeAttribute('aria-current');
        });
        if (nav && chapters.length) {
          const first = chapters[0].getBoundingClientRect();
          const last = chapters[chapters.length - 1].getBoundingClientRect();
          nav.style.setProperty('--story-progress', clamp((height * .4 - first.top) / Math.max(1,last.bottom - first.top)));
        }
      };
      const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(render); };
      window.addEventListener('scroll', schedule, {passive:true,signal});
      window.addEventListener('resize', schedule, {signal});
      reduced.addEventListener('change', () => { applyMotion(); schedule(); }, {signal});
      this.addEventListener('click', event => {
        const link = event.target.closest('.story-chapters a, .story-opening__bottom>a');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const id = link.getAttribute('href').slice(1);
        const target = document.getElementById(id);
        if (!target || !this.contains(target)) return;
        event.preventDefault();
        const cloudTarget = target.querySelector('[data-story-cloud]');
        const copy = cloudTarget || target.querySelector('.story-chapter__text') || target;
        copy.querySelector('[data-story-heading]')?.classList.add('is-read');
        const rect = copy.getBoundingClientRect();
        const header = document.querySelector('.header');
        const headerBottom = Math.max(0,Math.min(innerHeight*.25,header?.getBoundingClientRect().bottom || 0));
        const bottomSpace = nav ? Math.max(70,nav.offsetHeight+30) : 24;
        const available = innerHeight - headerBottom - bottomSpace;
        const contentHeight = cloudTarget ? cloudTarget.querySelector('.story-cloud-stage').offsetHeight : rect.height;
        const top = scrollY + rect.top - headerBottom - Math.max(24,(available - contentHeight)/2);
        window.scrollTo({top:Math.max(0,top),behavior:motionEnabled()?'smooth':'instant'});
      }, {signal});
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const block = event.target.closest('[data-story-chapter], [data-story-community]');
        block?.querySelector('[data-story-heading]')?.classList.add('is-read');
        block?.scrollIntoView({behavior:'instant',block:'start'});
      }, {signal});
      const opening = this.querySelector('.story-opening');
      if (opening && 'IntersectionObserver' in window) {
        this.coastObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            opening.classList.add('coast-is-drawn');
            this.coastObserver.disconnect();
          }
        }, {threshold:.15});
        this.coastObserver.observe(opening);
      } else opening?.classList.add('coast-is-drawn');
      applyMotion();
      render();
    }
    cleanup() {
      this.abort?.abort();
      this.reveal?.disconnect();
      this.coastObserver?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
    disconnectedCallback() { this.cleanup(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-product-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  function placeRelated() {
    const content = document.querySelector('#main .product-single__content');
    const related = document.querySelector('[data-ch-pdp-related]');
    if (!content || !related) return;
    if (related.parentElement !== content) content.append(related);
    related.hidden = false;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeRelated, { once: true });
  else placeRelated();
  document.addEventListener('shopify:section:load', placeRelated);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ch-shop-catalog-controls"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('coastline-shop-controls')) {
 customElements.define('coastline-shop-controls',class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort();this.abort=new AbortController();
   const signal=this.abort.signal;
   let pendingURL=null;
   const typeKey='filter.p.product_type';
   const values=text=>(text||'').split(',').map(x=>x.trim()).filter(Boolean);
   const baseURL=()=>{const url=new URL(pendingURL||location.href);url.pathname=this.dataset.collectionUrl;url.searchParams.delete('page');url.hash=document.querySelector('[data-category-catalog]')?'category-lineup':'shop-lineup';return url;};
   const syncGroupChip=()=>{
    const container=document.querySelector('.collection__filters-active__wrapper');if(!container)return;
    container.querySelectorAll('[data-shop-group-chip]').forEach(e=>e.remove());
    container.querySelectorAll('[data-shop-hidden-type]').forEach(e=>{e.hidden=false;e.removeAttribute('data-shop-hidden-type');});
    const params=new URL(pendingURL||location.href).searchParams;
    const active=params.getAll(typeKey).flatMap(values).sort();if(active.length<2)return;
    const preset=[...this.querySelectorAll('[data-shop-types]')].find(e=>JSON.stringify(values(e.dataset.shopTypes).sort())===JSON.stringify(active));if(!preset)return;
    container.querySelectorAll('a.js-filter-trigger:not(.collection__filters-active__filter--clear)').forEach(e=>{
     const remaining=new URL(e.href,location.href).searchParams.getAll(typeKey).flatMap(values);
     if(remaining.length===active.length-1&&remaining.every(v=>active.includes(v))){e.hidden=true;e.setAttribute('data-shop-hidden-type','');}
    });
    const chip=document.createElement('a');chip.className='collection__filters-active__filter';chip.dataset.shopGroupChip='';
    const url=baseURL();url.searchParams.delete(typeKey);chip.href=url.href;
    chip.textContent=preset.dataset.shopGroupLabel+' ×';chip.setAttribute('aria-label','Remove '+preset.dataset.shopGroupLabel+' filter');
    chip.addEventListener('click',event=>{if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();update(url);},{signal});
    container.append(chip);
   };
   const sync=()=>{
    const params=new URL(pendingURL||location.href).searchParams;
    const active=params.getAll(typeKey).flatMap(values).sort();
    this.querySelectorAll('[data-shop-types]').forEach(link=>{
     const group=values(link.dataset.shopTypes).sort();
     const selected=JSON.stringify(group)===JSON.stringify(active);
     link.classList.toggle('is-active',selected);
     if(selected)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');
     const url=baseURL();url.searchParams.delete(typeKey);group.forEach(value=>url.searchParams.append(typeKey,value));link.href=url.href;
    });
    const select=this.querySelector('[name="sort_by"]');
    const current=params.get('sort_by')||this.dataset.defaultSort;
    if(select&&[...select.options].some(option=>option.value===current))select.value=current;
    syncGroupChip();
   };
   const update=url=>{
    const grid=document.querySelector('dynamic-product-search');
    if(!grid||typeof grid.renderCollection!=='function'){location.assign(url.href);return;}
    grid.abortController?.abort();pendingURL=url.href;
    this.setAttribute('aria-busy','true');
    this.querySelector('[data-shop-status]').textContent='Updating products.';
    sync();grid.renderCollection({query:url.searchParams.toString(),updateURL:true,scrollUp:false});
   };
   this.addEventListener('click',event=>{
    if(event.target.closest('[data-shop-open-filters]')){event.preventDefault();const dialog=document.querySelector('filters-dialog#filters');dialog?.open?.();return;}
    const link=event.target.closest('[data-shop-types]');if(!link)return;
    if(link.getAttribute('aria-disabled')==='true'){event.preventDefault();return;}
    if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    event.preventDefault();const url=baseURL();url.searchParams.delete(typeKey);values(link.dataset.shopTypes).forEach(value=>url.searchParams.append(typeKey,value));update(url);
   },{signal});
   const sort=event=>{event.preventDefault();const url=baseURL();url.searchParams.set('sort_by',this.querySelector('[name="sort_by"]')?.value||this.dataset.defaultSort);update(url);};
   this.addEventListener('submit',sort,{signal});
   this.addEventListener('change',event=>{if(event.target.matches('[name="sort_by"]'))sort(event);},{signal});
   window.addEventListener('popstate',sync,{signal});
   const initialize=()=>{
    if(!this.isConnected)return;
    const grid=document.querySelector('dynamic-product-search');
    grid?.addEventListener('on:dynamic-product-search:loaded',async()=>{
     // A category navigation replaces this control with the destination's own markup.
     if(new URL(grid.dataset.url,location.href).pathname!==this.dataset.collectionUrl)return;
     pendingURL=null;this.removeAttribute('aria-busy');sync();
     this.refresh?.abort();this.refresh=new AbortController();
     try{
      const url=baseURL();url.searchParams.set('section_id',this.dataset.sectionId);
      const response=await fetch(url.href,{signal:this.refresh.signal});if(!response.ok)return;
      const html=new DOMParser().parseFromString(await response.text(),'text/html');const source=html.querySelector('coastline-shop-controls');if(!source||!this.isConnected)return;
      const oldCategories=this.querySelector('.shop-controls__categories'),newCategories=source.querySelector('.shop-controls__categories');if(oldCategories&&newCategories)oldCategories.innerHTML=newCategories.innerHTML;
      if(!this.contains(document.activeElement)&&this.querySelector('form')&&source.querySelector('form'))this.querySelector('form').innerHTML=source.querySelector('form').innerHTML;
      const oldCount=this.querySelector('.shop-controls__count'),newCount=source.querySelector('.shop-controls__count');if(oldCount&&newCount)oldCount.textContent=newCount.textContent;
      this.querySelector('[data-shop-status]').textContent='Products updated.';sync();
     }catch(error){if(error.name!=='AbortError')this.querySelector('[data-shop-status]').textContent='Products updated.';}
    },{signal});
    grid?.addEventListener('on:dynamic-product-search:failed',()=>{pendingURL=null;this.removeAttribute('aria-busy');this.querySelector('[data-shop-status]').textContent='Could not update products. Please try again.';sync();},{signal});
    sync();
   };
   if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true,signal});else initialize();
  }
  disconnectedCallback(){this.abort?.abort();this.refresh?.abort();}
 });
}


  } catch(e) { console.error(e); }
})();
})();
